<template>
  <div>
    <pageTitle title='酒店介绍' :bottomExtend='true'></pageTitle>
    <div class="topBlock whiteBg radius">
      <a>
        <span class="title">{{hotelInfo.HotelName}}</span>
      </a>
      <p>
        <mu-icon style='margin-right:-10px;top:2px;position:relative;' value="room" color="#D4D4D4" :size='13' />&nbsp;&nbsp;
        {{hotelInfo.Address}}
        <router-link class="map radius" to="/search/mapbook">
          地图和周边
        </router-link>
      </p>
      <p>
        <mu-icon style='margin-right:-10px;top:2px;position:relative;' value="call" color="#D4D4D4" :size='13' />&nbsp;&nbsp;
        <a style='color:#999999' :href="'tel:'+hotelInfo.Phone">{{hotelInfo.Phone}}</a>
      </p>
    </div>
    <div class="list">
      <div class="title">酒店介绍</div>
      <mu-divider/>
      <div class="content">
        {{hotelInfo.Presentation}}
      </div>
      <div class="title">酒店设施</div>
      <mu-divider/>
      <div class="content">
        <p>
          <label>提示</label>
          <span>{{msg.hint}}</span>
        </p>
        <p>
          <label>网络</label>
          <span>{{msg.wifi}}{{msg.band}}</span>
        </p>
        <p>
          <label>停车场</label>
          <span>{{msg.park}}</span>
        </p>
        <p>
          <label>自助机</label>
          <span>{{msg.selfservicemachine}}</span>
        </p>
        <p>
          <label>餐厅</label>
          <span>{{msg.food}}</span>
        </p>
        <p>
          <label>早餐服务</label>
          <span>{{msg.bf}}</span>
        </p>
        <p>
          <label>会议室</label>
          <span>{{msg.conRoom}}</span>
        </p>
        <p>
          <label>洗衣服务</label>
          <span>{{msg.laundry}}</span>
        </p>
        <p>
          <label>行李寄存</label>
          <span>{{msg.luggage}}</span>
        </p>
        <p>
          <label>接待外宾</label>
          <span>{{msg.forGue}}</span>
        </p>
        <p>
          <label>银行卡</label>
          <span>{{msg.unionPay}}</span>
        </p>
        <p>
          <label>客房设施</label>
          <span style="width:auto" v-for="fac in msg.facilities">{{fac}}</span>
        </p>
      </div>
    </div>
  </div>
</template>

<style lang="less" scoped>
@import "../../assets/theme.less";
.list{
    padding-top:1px;
    padding-bottom:2rem;
    margin-top: 0.2rem;
    .title{
        color:@primaryBlack;
        font-size:0.3rem;
        padding-left:15px;
        margin:15px;
        border-left:3px solid #27BA69;
        font-weight:600;
    }
    .content{
        margin:15px;
        font-size:0.26rem;
        color:@secondBlack;
        p{
            label{
                margin-top:3px;
                vertical-align: top;
                color:@primaryBlack;
                font-size:0.26rem;
                width:1.33rem;
                display:inline-block;
                position:relative;
                line-height:100%;
                font-weight:600;
            }
            span{
                display:inline-block;
                width:5.31rem;
                font-size:0.26rem;
                color:@secondBlack;
            }
        }
    }
}
.topBlock {
  .title{
    font-weight:600;
    color:@primaryBlack;
    font-size:0.3rem;
    display:inline-block;
  }
  p{
    margin:0.14rem 0 0 0;
    font-size:0.22rem;
  }
}
</style>

<script>
import api from '../../api'
import { mapMutations } from 'vuex'
import { mapGetters } from 'vuex'
import HService from '../../utils/hotelService.js'
export default {
  data () {
    return {
      msg: {},
      hotelInfo: {},
      lastHotelCode: ''
    }
  },
  activated(){
    if(this.lastHotelCode != this.g_currentInfo.HotelCode || this.lastHotelCode == ''){
      this.init()
      this.gethoteldetail()
    }
  },
  methods: {
    init(){
      this.msg = {
        //提示
        hint:'',
        //停车场
        park:'无',
        //自助机
        selfservicemachine:'无',
        //早餐
        bf: '无早餐服务',
        //餐厅
        food: '',
        //wifi
        wifi: '无Wifi',
        //宽带
        band: '无宽带',
        //会议室
        conRoom: '',
        //洗衣店
        laundry: '无洗衣室',
        //行李寄存
        luggage: '无',
        //接待外宾
        forGue: '暂无',
        //银行卡
        unionPay: '不支持银行卡',
        //酒店设施
        facilities: ['中央空调','','']
      },
      this.hotelInfo = {
        HotelName : '读取中..',
        Phone: '读取中..',
        Address: '读取中..',
        Presentation: '读取中..'
      }
    },
    getService(items){
      for (var item in items)
      {
        HService.getService(items[item],this.msg);
      }
    },
    goback(){
      javascript: history.go(-1);
    },
    // 获取房型信息
    gethoteldetail() {
      var params = new this.URLSearchParam()
      params.append('hotelCode', this.g_currentInfo.HotelCode)
      params.append('startDate', this.g_searchParam.startDate)
      params.append('endDate', this.g_searchParam.endDate)
      this.$http.post(api.getHotelDetail(), params.toParam()).then((res) => {
        if (res.Result) {
          this.hotelInfo = res.Data
          this.lastHotelCode = this.g_currentInfo.HotelCode
          this.getService(this.hotelInfo.HotelServiceListAll)
        }
      })
    },
  },
  computed:{
    ...mapGetters([
      'g_currentInfo', 'g_searchParam'
    ]),
  },
}
</script>


// WEBPACK FOOTER //
// hotailDetail.vue?65c65152